import {
  ADD_LEI_ISSUER,
  CHANGE_LOADING,
  CHANGE_MODIFICATION_TYPE,
  CLEAR_ISIN,
  RESET_CRITERIA_MODIFICATION,
  RESET_RECORD_INFO,
  SET_ADDRESS_DATA,
  SET_ASSOCIATED_ENTITY,
  SET_BRANCHES,
  SET_BRANCH_RELATIONSHIPS_DATA,
  SET_CRITERIA_MODIFICATION,
  SET_DIRECT_CHILDREN,
  SET_DIRECT_CHILD_RELATIONSHIPS,
  SET_DIRECT_CHILD_RELATIONSHIPS_DATA,
  SET_DIRECT_PARENT,
  SET_DIRECT_PARENT_RELATIONSHIP,
  SET_DIRECT_PARENT_REPORTING_EXCEPTION,
  SET_ELF,
  SET_ENTITY_RA,
  SET_FEEDER_FUNDS,
  SET_FEEDER_FUND_RELATIONSHIPS_DATA,
  SET_FUND_MANAGER,
  SET_FUND_MANAGER_RELATIONSHIP_DATA,
  SET_HEAD_OFFICE,
  SET_HEAD_OFFICE_RELATIONSHIP_DATA,
  SET_ISIN,
  SET_MANAGED_FUNDS,
  SET_MANAGED_FUND_RELATIONSHIPS_DATA,
  SET_MASTER_FUND,
  SET_MASTER_FUND_RELATIONSHIP_DATA,
  SET_MODIFICATIONS,
  SET_OVA,
  SET_RA,
  SET_RECORD,
  SET_RECORD_MODIFICATIONS,
  SET_RECORD_XML,
  SET_RR_XML,
  SET_REPEX_XML,
  SET_SUB_FUNDS,
  SET_SUB_FUND_RELATIONSHIPS_DATA,
  SET_SUCCESSOR_ENTITIES,
  SET_SUCCESSOR_ENTITY,
  SET_ULTIMATE_CHILDREN,
  SET_ULTIMATE_CHILD_RELATIONSHIPS,
  SET_ULTIMATE_CHILD_RELATIONSHIPS_DATA,
  SET_ULTIMATE_PARENT,
  SET_ULTIMATE_PARENT_RELATIONSHIP,
  SET_ULTIMATE_PARENT_REPORTING_EXCEPTION,
  SET_UMBRELLA_FUND,
  SET_UMBRELLA_FUND_RELATIONSHIP_DATA,
  SHOW_RECORD_EXCEPTION,
  TOGGLE_CHANGES_MODAL,
  TOGGLE_DISPLAY_SECTION,
  TOGGLE_FULL_DATA_MODAL,
  TOGGLE_ISSUER_MODAL,
  TOGGLE_MODIFICATIONS_MODAL,
  TOGGLE_RELATIONSHIP_MODAL,
} from '@/store/modules/record/mutations-types'

import Vue from 'vue'
import { parseRecord, } from '@/store/modules/record/helpers/parsing'
import { templateCriteriaModifications, } from './helpers/actions-helper'

export default {
  [SET_RECORD] (state, { recordPublishDate, record, }) {
    let recordWithPublishDate = record
    recordWithPublishDate.recordPublishDate = recordPublishDate
    state.record = parseRecord(recordWithPublishDate)
    state.rawRecord = record
  },
  [SET_ADDRESS_DATA] (state, { res, type, }) {
    state.addressData = {
      addressData: res,
      type,
    }
  },
  [SHOW_RECORD_EXCEPTION] (state, show) {
    state.recordNotFound = show
  },
  [RESET_RECORD_INFO] (state) {
    state.recordNotFound = false
    state.record = null
    state.directChildren = []
    state.ultimateChildren = []
    state.directChildrenCount = 0
    state.ultimateChildrenCount = 0
    state.ultimateParent = null
    state.directParent = null
    state.leiIssuers = {}
    state.handledAssociatedEntity = null
    state.handledSuccessorEntity = null
    state.rawSuccessorEntities = null
    state.ultimateParentRelationship = null
    state.directParentRelationship = null
    state.ultimateParentReportingException = null
    state.directParentReportingException = null
    state.ultimateChildReportingException = null
    state.directChildReportingException = null
    state.showUltimateChildrenMoreBtn = false
    state.showDirectChildrenMoreBtn = false
    state.ultimateChildrenRelationships = []
    state.directChildrenRelationships = []
    state.isin = null
    state.elf = null
    state.ra = null
    state.recordModifications = {
      lei: {},
      rr: {},
      repex: {},
      changed: false,
    }
    state.xmlData = {
      lei: {
        record: {
          lei: null,
          xml: '',
        },
      },
      rr: {
        directParent: {
          lei: null,
          xml: '',
        },
        ultimateParent: {
          lei: null,
          xml: '',
        },
        fundManager: {
          lei: null,
          xml: '',
        },
        umbrellaFund: {
          lei: null,
          xml: '',
        },
        masterFund: {
          lei: null,
          xml: '',
        },
        headOffice: {
          lei: null,
          xml: '',
        },
      },
      repex: {
        directParentException: {
          lei: null,
          xml: '',
        },
        ultimateParentException: {
          lei: null,
          xml: '',
        },
      },
    },
    state.headOffice = null
    state.branches = []
    state.fundManager = null
    state.managedFunds = []
    state.umbrellaFund = null
    state.subFunds = []
    state.masterFund = null
    state.feederFunds = []
    state.branchesCount = 0
    state.managedFundsCount = 0
    state.subFundsCount = 0
    state.feederFundsCount = 0
    state.showBranchesMoreBtn = false
    state.showManagedFundsMoreBtn = false
    state.showSubFundsMoreBtn = false
    state.showFeederFundsMoreBtn = false
    state.headOfficeRelationship = null
    state.branchesRelationships = []
    state.fundManagerRelationship = null
    state.managedFundsRelationships = []
    state.umbrellaFundRelationship = null
    state.subFundsRelationships = []
    state.masterFundRelationship = null
    state.feederFundsRelationships = []
    state.addressData = {
      addressData: null,
      type: null,
    }
  },
  [SET_RA] (state, { data, needOther, }) {
    state.ra = needOther ? state.record.entity.registeredAt : data.attributes
  },
  [SET_OVA] (state, { data, ra, needOther, }) {
    state.record.registration.otherValidationAuthorities[ra.index].validatedAt.id = needOther ?
      state.record.registration.otherValidationAuthorities[ra.index].validatedAt.id : data.attributes
  },
  [SET_ENTITY_RA] (state, { data, needOther, }) {
    state.record.registration.validatedAt.id = needOther ? state.record.registration.validatedAt.id : data.attributes
  },
  [SET_ELF] (state, { data, needOther, }) {
    state.elf = needOther ? state.record.entity.legalForm : data.attributes
  },
  [SET_ISIN] (state, data) {
    state.isin = {
      ...state.isin,
      ...data,
    }
    if (data.meta.pagination.currentPage === 1) {
      state.isin.firstFive = data.data.slice(0, 5)
    }
  },
  [CLEAR_ISIN] (state) {
    state.isin = null
  },
  [SET_MODIFICATIONS] (state, {
    data,
    meta: { pagination: { total, perPage, lastPage, currentPage, }, },
  }) {
    state.modifications = data.map(({ attributes, }) => ({ ...attributes, }))
    state.timelineTable = {
      total,
      perPage,
      lastPage,
      currentPage,
    }
  },
  [SET_RECORD_MODIFICATIONS] (state, { modificationsData, }) {
    state.recordModifications[modificationsData.type] = modificationsData
    state.recordModifications.changed = true
  },
  [SET_ULTIMATE_CHILDREN] (state, {
    data,
    meta: { pagination: { lastPage, currentPage, total, }, },
  }) {
    state.ultimateChildrenCount = total
    state.showUltimateChildrenMoreBtn = lastPage > currentPage
    state.ultimateChildren =
      [ ...state.ultimateChildren, ...data.map((child) => parseRecord(child)), ]
  },
  [SET_DIRECT_CHILDREN] (state, {
    data,
    meta: { pagination: { lastPage, currentPage, total, }, },
  }) {
    state.directChildrenCount = total
    state.showDirectChildrenMoreBtn = lastPage > currentPage
    state.directChildren = [ ...state.directChildren, ...data.map((child) => parseRecord(child)), ]
  },
  [SET_ULTIMATE_PARENT] (state, { data, }) {
    state.ultimateParent = parseRecord(data)
  },
  [SET_DIRECT_PARENT] (state, { data, }) {
    state.directParent = parseRecord(data)
  },
  [ADD_LEI_ISSUER] (state, { data, }) {
    Vue.set(state.leiIssuers, data.id, parseRecord(data))
  },
  [SET_SUCCESSOR_ENTITY] (state, { data, }) {
    state.handledSuccessorEntity = parseRecord(data)
  },
  [SET_SUCCESSOR_ENTITIES] (state, { data, }) {
    state.rawSuccessorEntities = data
  },
  [SET_ASSOCIATED_ENTITY] (state, { data, }) {
    state.handledAssociatedEntity = parseRecord(data)
  },
  [SET_ULTIMATE_PARENT_RELATIONSHIP] (state, { data, }) {
    state.ultimateParentRelationship = parseRecord(data)
  },
  [SET_DIRECT_PARENT_RELATIONSHIP] (state, { data, }) {
    state.directParentRelationship = parseRecord(data)
  },
  [SET_ULTIMATE_PARENT_REPORTING_EXCEPTION] (state, { data, }) {
    state.ultimateParentReportingException = parseRecord(data)
  },
  [SET_DIRECT_PARENT_REPORTING_EXCEPTION] (state, { data, }) {
    state.directParentReportingException = parseRecord(data)
  },
  [SET_ULTIMATE_CHILD_RELATIONSHIPS] (state, { data, }) {
    state.ultimateChildReportingException = data
  },
  [SET_DIRECT_CHILD_RELATIONSHIPS] (state, { data, }) {
    state.directChildReportingException = data
  },
  [SET_ULTIMATE_CHILD_RELATIONSHIPS_DATA] (state, { data, }) {
    state.ultimateChildrenRelationships = [ ...state.ultimateChildrenRelationships, ...data, ]
  },
  [SET_DIRECT_CHILD_RELATIONSHIPS_DATA] (state, { data, }) {
    state.directChildrenRelationships = [ ...state.directChildrenRelationships, ...data, ]
  },
  [CHANGE_LOADING] (state, val) {
    state.loading = val
  },
  [CHANGE_MODIFICATION_TYPE] (state, value) {
    state.modificationType = value
  },
  [TOGGLE_DISPLAY_SECTION] (state, { value, property, }) {
    if (typeof value === 'boolean') {
      state[property] = value
    } else {
      state[property] = !state[property]
    }
  },
  [TOGGLE_RELATIONSHIP_MODAL] (state, { show, parent, child, exception, info, }) {
    state.relationship = {
      parent: parent || state.record,
      child: child || state.record,
      exception: exception || null,
      info,
    }
    state.showRelationshipData = show
  },
  [TOGGLE_FULL_DATA_MODAL] (state, { show, fullList, }) {
    state.showFullData = show && fullList
  },
  [TOGGLE_MODIFICATIONS_MODAL] (state, { show, }) {
    state.showModificationsModal = show || !state.showModificationsModal
  },
  [TOGGLE_CHANGES_MODAL] (state, { show, }) {
    state.showChangesModal = show || !state.showChangesModal
  },
  [TOGGLE_ISSUER_MODAL] (state, show) {
    state.showIssuerModal = show
  },
  [SET_CRITERIA_MODIFICATION] (state, criteria) {
    state.criteriaModifications = {
      ...state.criteriaModifications,
      ...criteria,
    }
  },
  [RESET_CRITERIA_MODIFICATION] (state) {
    state.criteriaModifications = templateCriteriaModifications()
  },
  [SET_HEAD_OFFICE] (state, { data, }) {
    state.headOffice = parseRecord(data)
    // console.log('headOffice', state.headOffice)
  },
  [SET_BRANCHES] (state, {
    data,
    meta: { pagination: { lastPage, currentPage, total, }, },
  }) {
    state.branchesCount = total
    state.showBranchesMoreBtn = lastPage > currentPage
    state.branches =
      [ ...state.branches, ...data.map((branch) => parseRecord(branch)), ]
    // console.log('branches', state.branches)
  },
  [SET_FUND_MANAGER] (state, { data, }) {
    state.fundManager = parseRecord(data)
    // console.log('fundManager', state.fundManager)
  },
  [SET_MANAGED_FUNDS] (state, {
    data,
    meta: { pagination: { lastPage, currentPage, total, }, },
  }) {
    state.managedFundsCount = total
    state.showManagedFundsMoreBtn = lastPage > currentPage
    state.managedFunds =
      [ ...state.managedFunds, ...data.map((fund) => parseRecord(fund)), ]
    // console.log('managedFunds', state.managedFunds)
  },
  [SET_UMBRELLA_FUND] (state, { data, }) {
    state.umbrellaFund = parseRecord(data)
    // console.log('umbrellaFund', state.umbrellaFund)
  },
  [SET_SUB_FUNDS] (state, {
    data,
    meta: { pagination: { lastPage, currentPage, total, }, },
  }) {
    state.subFundsCount = total
    state.showSubFundsMoreBtn = lastPage > currentPage
    state.subFunds =
      [ ...state.subFunds, ...data.map((fund) => parseRecord(fund)), ]
    // console.log('subFunds', state.subFunds)
  },
  [SET_MASTER_FUND] (state, { data, }) {
    state.masterFund = parseRecord(data)
    // console.log('masterFund', state.masterFund)
  },
  [SET_FEEDER_FUNDS] (state, {
    data,
    meta: { pagination: { lastPage, currentPage, total, }, },
  }) {
    state.feederFundsCount = total
    state.showFeederFundsMoreBtn = lastPage > currentPage
    state.feederFunds =
      [ ...state.feederFunds, ...data.map((fund) => parseRecord(fund)), ]
    // console.log('feederFunds', state.feederFunds)
  },

  [SET_HEAD_OFFICE_RELATIONSHIP_DATA] (state, { data, }) {
    state.headOfficeRelationship = parseRecord(data)
  },

  [SET_BRANCH_RELATIONSHIPS_DATA] (state, { data, }) {
    state.branchesRelationships = [ ...state.branchesRelationships, ...data, ]
  },

  [SET_FUND_MANAGER_RELATIONSHIP_DATA] (state, { data, }) {
    state.fundManagerRelationship = parseRecord(data)
  },

  [SET_MANAGED_FUND_RELATIONSHIPS_DATA] (state, { data, }) {
    state.managedFundsRelationships = [ ...state.managedFundsRelationships, ...data, ]
  },

  [SET_MASTER_FUND_RELATIONSHIP_DATA] (state, { data, }) {
    state.masterFundRelationship = parseRecord(data)
  },

  [SET_FEEDER_FUND_RELATIONSHIPS_DATA] (state, { data, }) {
    state.feederFundsRelationships = [ ...state.feederFundsRelationships, ...data, ]
  },

  [SET_UMBRELLA_FUND_RELATIONSHIP_DATA] (state, { data, }) {
    state.umbrellaFundRelationship = parseRecord(data)
  },

  [SET_SUB_FUND_RELATIONSHIPS_DATA] (state, { data, }) {
    state.subFundsRelationships = [ ...state.subFundsRelationships, ...data, ]
  },

  [SET_RECORD_XML] (state, { id, data, }) {
    state.xmlData.lei.record = {
      lei: id,
      xml: data,
    }
  },
  [SET_RR_XML] (state, { id, data, relationshipType, }) {
    if (state.xmlData.rr.hasOwnProperty(relationshipType)) {
      state.xmlData.rr[relationshipType] = {
        lei: id,
        xml: data,
      }
    }
  },
  [SET_REPEX_XML] (state, { id, data, relationshipType, }) {
    if (state.xmlData.repex.hasOwnProperty(relationshipType)) {
      state.xmlData.repex[relationshipType] = {
        lei: id,
        xml: data,
      }
    }
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/record/mutations.js